import { Flex, Image, Text } from "components/Base";
import profileStore from "lib/stores/entities/profile";
import { BiChevronRight } from "react-icons/bi";
import { Link } from "react-router-dom";
import { getColor } from "utils/general";

function PointCard() {
  const user = profileStore((s) => s.user);

  if (!user) {
    return null;
  }

  return (
    <Flex
      direction="column"
      w="100%"
      br="$rounded-lg"
      bgColor="$secondary4"
      p="18px"
      gap="12px"
      position="relative"
    >
      <Flex alignItems="center" gap="14px">
        <Text
          color="$secondary"
          weight="$bold"
          fontSize="32px"
          lineHeight="42px"
        >
          {user.total_point}
        </Text>
        <Text lineHeight="22px">Total Poin</Text>
      </Flex>
      <Link to="/profile?tab=point-history">
        <Flex alignItems="center" gap="14px" zIndex={3}>
          <Text color="$secondary" weight="$bold" lineHeight="22px">
            Cek Riwayat Poin
          </Text>
          <BiChevronRight color={getColor("secondary")} />
        </Flex>
      </Link>
      <Flex
        p="8px 20px"
        br="$rounded-full"
        bgColor="$white"
        gap="8px"
        zIndex={3}
        alignItems="center"
      >
        <Image
          src="/icons/medal.svg"
          alt="Sigap Medal"
          h="24px"
          css={{ color: user.badge.color }}
        />
        <Text fontSize="$lg" color={user.badge.color} weight="$bold">
          {user.badge.name}
        </Text>
      </Flex>
      <Image
        src="/images/logo-transparent.png"
        position="absolute"
        right="0"
        top="10px"
      />
    </Flex>
  );
}

export default PointCard;
